<template>
  <div class="film-home position-relative">
    <b-overlay :show="platformBusy">
      <portlet title="يېڭىدىن سۇپا قوشۇش">
        <template v-slot:body>
          <platform-form
              ref="platform"
              action="edit"
              :model-id="modelId"
              @loading="onLoading"
              @loaded="onLoaded"
              @updating="onLoading"
              @updated="onUpdated"
          />
        </template>
        <template v-slot:foot>
          <b-button id="submit" @click="handleSubmit" variant="primary">
            ساقلاش
          </b-button>
          <b-button :to="{name: 'platform.home'}" class="ml-2" variant="danger">
            بىكار قىلىش
          </b-button>
        </template>
      </portlet>
    </b-overlay>
  </div>
</template>

<script>
  import Portlet from "@v@/partials/content/Portlet";
  import PlatformForm from "@v@/components/forms/PlatformForm";
  import formBusyMixin from "@m@/common/formBusy.mixin";
  import BreadCrumbs from "@c@/breadcrumbs.service";
  import msgBoxConfirmMixin from "@m@/common/msgBoxConfirmMixin";
  import sweetAlertMixin from "@m@/common/sweetAlert.mixin";
  import {debugConsole} from "@c@/helpers/helpers";

  export default {
    name: "edit",
    components: { Portlet, PlatformForm },
    mixins: [formBusyMixin, msgBoxConfirmMixin, sweetAlertMixin],
    data(){
      return {
        platformBusy: false,
        form: {}
      };
    },
    computed: {
      modelId(){
        if ( this.$route.hasOwnProperty('params') )
          return this.$route.params.id;
      },
    },
    created() {},
    mounted() {
      BreadCrumbs.setBreadCrumb([]);
      BreadCrumbs.addBreadCrumb({title: 'سۇپا باشقۇرۇش', route: {name: 'platform.home'}});
      BreadCrumbs.addBreadCrumb({title: 'يېڭىدىن قوشۇش'});
      if ( this.$refs.hasOwnProperty('platform') ){
        this.form = this.$refs['platform'];
      }
    },
    methods: {
      handleSubmit(){
        this.form.onSubmit();
      },
      onLoading(){
        this.showBusy('platformBusy');
        debugConsole({prefix: 'platform', message: 'onLoading'})
      },
      onLoaded({response, state}){
        this.hideBusy('platformBusy');
        debugConsole({prefix: 'platform', message: `onLoaded: ${state}`});
      },
      onUpdated({response, state}){
        this.hideBusy('platformBusy');
        debugConsole({prefix: 'platform', message: `onUpdated: ${state}`});
        if ( state === 'success' ){
          this.success({ message: 'سۇپا ئۇچۇرى تەھرىرلەش مۇۋاپىقىيەتلىك بولدى.' });
        }
      },
    }
  }
</script>

<style scoped>
  .btn i {
    padding-left: 0;
  }
</style>
